/**
 * Spinner.
 *
 * 16px default. SVG-based so it inherits color via currentColor. Used inside
 * buttons and for inline >500ms actions.
 */
import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/cn';

export interface SpinnerProps {
  className?: string;
  label?: string;
}

export function Spinner({ className, label = 'Loading' }: SpinnerProps) {
  return (
    <Loader2
      role="status"
      aria-label={label}
      className={cn('animate-spin', className ?? 'h-4 w-4')}
      strokeWidth={1.5}
    />
  );
}
